export default __webpack_public_path__ + "static/worldCup-362fd19789bfc69010a7b2a8bc2519a2.svg";